import { VoidedMatchBanner } from './VoidedMatchBanner';

export default VoidedMatchBanner;
